import { render } from "./CourseDeleteConfirmDialog.vue?vue&type=template&id=e2f3d0e4"
import script from "./CourseDeleteConfirmDialog.vue?vue&type=script&lang=js"
export * from "./CourseDeleteConfirmDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__